import { render, staticRenderFns } from "./SurveillanceLabResults.vue?vue&type=template&id=7543b7bc&scoped=true&"
import script from "./SurveillanceLabResults.vue?vue&type=script&lang=js&"
export * from "./SurveillanceLabResults.vue?vue&type=script&lang=js&"
import style0 from "./SurveillanceLabResults.vue?vue&type=style&index=0&id=7543b7bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7543b7bc",
  null
  
)

export default component.exports